
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { SessionUser } from '@/core/types/session-user';
import { SessionService } from '@/core/services/session';
import ProfileAccountDropdown from '@/profile/components/ProfileAccountDropdown.vue';
import { ProfileFI } from '@/profile/types/profile-fi';

const coreNamespace = namespace('core');
const profileNamespace = namespace('profile');

@Component({
	components: {
		ProfileAccountDropdown,
	},
})
export default class ProfileTopbar extends Vue {
	@profileNamespace.State('institutions')
	institutions!: ProfileFI[];

	@coreNamespace.Getter('user')
	public user!: SessionUser;

	get userName(): string {
		return this.user?.name ?? '';
	}

	public logout(): void {
		SessionService.logout();
	}

	get logoUrl(): string {
		return this.institutions[0]?.logoFullUrl ?? '';
	}

	get fiName(): string {
		return this.institutions[0]?.name ?? '';
	}
}
